import { TUser } from "core/models/auth.model";
import { userManager } from "./oidc.config";
import { persistor } from "store";

//--------------------------------------------------------- OIDC Services ------------------------------------------------------

export const login = () => userManager.signinRedirect();

export const loginCallback = () => userManager.signinRedirectCallback();

export const silentLogin = () => userManager.signinSilent();

export const signOut = () => userManager.signoutRedirect();

export const getUser = () => userManager.getUser();

//--------------------------------------------------------- renewAccessToken ------------------------------------------------------

let renewPromise: Promise<any> | null = null;

export const renewAccessToken = async () => {
  if (renewPromise) return renewPromise;

  renewPromise = (async () => {
    try {
      const user = await userManager.signinSilent();
      return user;
    } catch (err) {
      throw err;
    } finally {
      renewPromise = null;
    }
  })();

  return renewPromise;
};

//--------------------------------------------------------- getAccessToken ------------------------------------------------------

export const getAccessToken = async (): Promise<string | null> => {
  const user = await userManager.getUser();
  return user?.access_token ?? null;
};

//--------------------------------------------------------- forceLogout ------------------------------------------------------

export const forceLogout = async () => {
  await userManager.removeUser();
  await persistor.purge();
  signOut();
};

//--------------------------------------------------------- initAuthEvents ------------------------------------------------------

export const initAuthEvents = () => {
  userManager.events.addAccessTokenExpiring(async () => {
    try {
      console.log("Token expiring → attempting renew");

      await renewAccessToken();
    } catch (err) {
      console.warn("Silent renew failed", err);
    }
  });

  userManager.events.addAccessTokenExpired(async () => {
    console.warn("Token expired → forcing logout");

    await forceLogout();
  });
};

//--------------------------------------------------------- RedirectUrl ------------------------------------------------------

export const setRedirectUrl = (path: string) => {
  sessionStorage.setItem("redirectAfterLogin", path);
};

export const getRedirectUrl = () => {
  return sessionStorage.getItem("redirectAfterLogin");
};

export const removeRedirectUrl = () => {
  sessionStorage.removeItem("redirectAfterLogin");
};

export const redirectToSignOut = () => {
  window.location.pathname = "/signout-oidc";
};

